import BaseActionTypes from "../../base/BaseActionTypes";

const RESOURCE = "Vehicles";

const VehiclesActionTypes = {
  ...BaseActionTypes(RESOURCE),
};

export default VehiclesActionTypes;
